export interface PagingBaseModel {
  pageNumber?: number;
  itemsByPage?: number;
  totalItems?: number;
}
